/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconItalic = createReactComponent("outline", "italic", "IconItalic", [["path", { "d": "M11 5l6 0", "key": "svg-0" }], ["path", { "d": "M7 19l6 0", "key": "svg-1" }], ["path", { "d": "M14 5l-4 14", "key": "svg-2" }]]);

export { IconItalic as default };
//# sourceMappingURL=IconItalic.mjs.map
